/**
=========================================================
* Soft UI Dashboard PRO React - v3.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { useState, useContext, useEffect } from "react";

// @mui material components
import Card from "@mui/material/Card";
import SuiTypography from "components/SuiTypography";

import SuiBox from "components/SuiBox";
import SuiButton from "components/SuiButton";

import Icon from "@mui/material/Icon";
import Tooltip from "@mui/material/Tooltip";
import Switch from "@mui/material/Switch";
import toast from "react-hot-toast";

import EditIcon from "@mui/icons-material/Edit";
import ClearIcon from "@mui/icons-material/Clear";
import DoneIcon from "@mui/icons-material/Done";
import IconButton from "@mui/material/IconButton";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { useForm, Controller } from "react-hook-form";
import { capitalCase } from "capital-case";

const OurSpecialties = ({ store, updateStore, editable = true, tree = [], sx = {} }) => {
  const [editVisible, setEditVisible] = useState(false);
  const [productTypes, setProductTypes] = useState({});
  const { register, handleSubmit, trigger, setValue, getValues, reset, errors, control } = useForm(
    {}
  );

  useEffect(() => {
    const originalProductTypes = store?.product_type_meta || [
      { product_type_id: "Bags", min_units: 100 },
    ];
    const temp = {};
    for (let i = 0; i < originalProductTypes.length; i++) {
      temp[originalProductTypes[i]["product_type_id"]] = originalProductTypes[i]["min_units"];
    }
    setProductTypes(temp);
  }, [store]);

  const handleSwitchChange = (pt) => {
    const temp = { ...productTypes };
    if (temp.hasOwnProperty(pt)) {
      delete temp[pt];
    } else {
      temp[pt] = 0;
    }
    setProductTypes(temp);
  };
  const productTypesOption = [];
  for (let i = 0; i < tree.length; i++) {
    for (let j = 0; j < tree[i]["children"].length; j++) {
      productTypesOption.push({
        label: tree[i]["children"][j]["label"],
        id: tree[i]["children"][j]["id"],
      });
    }
  }

  const handleShowEdit = (e) => {
    setEditVisible(true);
  };

  const handleSave = async () => {
    const typesID = Object.keys(productTypes);
    const result = [];
    for (let i = 0; i < typesID.length; i++) {
      result.push({
        store_id: store.id,
        product_type_id: typesID[i],
        min_units: productTypes[typesID[i]],
      });
    }
    try {
      await updateStore({ product_type_meta: result });
      toast.success("Update product types successfully");
      setEditVisible(false);
    } catch (err) {
      toast.error("Update product types error");
    }
  };
  return (
    <Card sx={{ px: 2, minHeight: 300, ...sx }}>
      <form onSubmit={handleSubmit(handleSave)}>
        <div className="m-4">
          <div className="my-2  flex justify-between">
            <SuiTypography variant="h6" fontWeight="medium" textTransform="capitalize">
              Our Specialities
            </SuiTypography>
            {editable &&
              (editVisible ? (
                <div className="flex">
                  <Tooltip title={"Cancel"} placement="top">
                    <IconButton
                      aria-label="clear"
                      size="small"
                      onClick={() => setEditVisible(false)}
                    >
                      <ClearIcon color="error" />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title={"Save"} placement="top">
                    <IconButton aria-label="done" size="small" type="submit">
                      <DoneIcon color="success" />
                    </IconButton>
                  </Tooltip>
                </div>
              ) : (
                <Tooltip title={"Edit"} placement="top">
                  <IconButton aria-label="edit" size="small" onClick={handleShowEdit}>
                    <EditIcon color="dark" />
                    <SuiTypography
                      variant="h6"
                      fontWeight="bold"
                      textTransform="uppercase"
                      sx={{ ml: 1, fontSize: 14 }}
                      className="xsmall:hidden small:inline"
                    >
                      EDIT
                    </SuiTypography>
                  </IconButton>
                </Tooltip>
              ))}
          </div>
          <div className="grid xsmall:grid-cols-1 small:grid-cols-2 divide-y">
            {store?.metadata?.manufacturing_specialties
              ? store.metadata.manufacturing_specialties.map((pt, index) => (
                  <div key={index}>
                    <SuiTypography variant="caption" fontWeight="regular">
                      {capitalCase(pt, { stripRegexp: /[^A-Z0-9\'\&\/-_]/gi })}
                    </SuiTypography>
                  </div>
                ))
              : null}
          </div>
        </div>
      </form>
    </Card>
  );
};

export default OurSpecialties;
